module.exports = __webpack_public_path__ + "static/portland-c67365c65b820724dad58eae9aa4cafa.png";